import { Check } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { IMAGES } from "@/lib/api";

export default function BoatSection() {
  const { t } = useLang();
  const facts = [t.loc_label, t.loc_boat, t.loc_from, t.loc_min];
  return (
    <section id="bateau" className="scroll-mt-20 max-w-7xl mx-auto px-5 sm:px-10 py-24 sm:py-32 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center" data-testid="boat-section">
      <div className="lg:col-span-7 gold-frame p-3 group overflow-hidden">
        <img src={IMAGES.flyer} alt="Blue Army speedboat 28" className="w-full aspect-[4/3] object-cover object-[50%_55%] transition-transform duration-[1500ms] group-hover:scale-105" />
      </div>
      <div className="lg:col-span-5">
        <p className="text-[#D4AF37] tracking-[0.3em] text-xs uppercase mb-4">Blue Army · Speedboat 28'</p>
        <h2 className="font-display text-4xl sm:text-5xl leading-tight mb-8">{t.incl_title}</h2>
        <ul className="grid grid-cols-2 gap-4 mb-12">
          {t.incl.map((i) => (
            <li key={i} className="flex items-center gap-3 border border-white/10 px-4 py-3 text-sm" data-testid="inclusion-item">
              <span className="w-6 h-6 rounded-full bg-[#D4AF37] flex items-center justify-center shrink-0"><Check className="w-3.5 h-3.5 text-[#050B14]" /></span>{i}
            </li>
          ))}
        </ul>
        <div className="border-y border-[#D4AF37]/40 py-5 flex flex-wrap gap-x-6 gap-y-2 text-sm tracking-wide" data-testid="charter-facts">
          {facts.map((f, i) => <span key={f} className={i === 2 ? "text-[#D4AF37] font-medium" : "text-slate-300"}>{f}</span>)}
        </div>
      </div>
    </section>
  );
}
